import {
  ApolloClient, ApolloLink, HttpLink, InMemoryCache,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { createUploadLink } from 'apollo-upload-client';
import _ from 'lodash';
import { EMITTER_CONSTANTS } from '../../constants';
import auth from '../../utils/auth';
import emitter from '../../utils/eventEmitter';
import { toastrError } from '../../utils/toastNotification';
import CONFIG from '../config';


const { localStorage } = window;

const cache = new InMemoryCache({ addTypename: false });
const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
};

const createClient = (isUsingCache = false, isNotShowDisconnect = false) => {
  const accessToken = auth.getAccessToken();
  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      // Authorization: accessToken,
      'access-token': accessToken,
    },
  }));
  return new ApolloClient({
    link: authLink.concat(
      ApolloLink.from([
        onError(({
          graphQLErrors, networkError, response, operation, forward,
        }) => {
          if (graphQLErrors) {
            _.map(graphQLErrors, ({ message, extensions }) => {
              if (_.includes(message, '403') || _.includes(message, '400') || extensions.code === 'UNAUTHENTICATED') {
                emitter.emit(EMITTER_CONSTANTS.LOGOUT_REQUEST, 'request');
              }
            });
          } else if (networkError) {
            toastrError('Please check your network connection and try again', 'Network error');
          }
        }),
        new HttpLink({
          uri: CONFIG.APOLLO_HOST_URL,
          credentials: 'same-origin',
        }),
      ]),
    ),
    // *: name & version variables use for statistic purpose
    name: 'covid19-monitor',
    version: '1.0.0',
    cache,
    defaultOptions: isUsingCache ? undefined : defaultOptions,
  });
};

const createUploadClient = (isUsingCache = false) => {
  const uploadLink = createUploadLink({ uri: CONFIG.HOST_URL });
  const { token } = localStorage;
  if (!token) {
    return null;
  }
  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      'access-token': token,
    },
  }));
  const uploadClient = new ApolloClient({
    link: authLink.concat(uploadLink),
    // *: name & version variables use for statistic purpose
    name: 'NAME_PROJECT',
    version: '0.5.2',
    cache,
    defaultOptions: isUsingCache ? undefined : defaultOptions,
  });

  return uploadClient;
};

export { createUploadClient };

export default createClient;
